import i18n from './../../../../shared/i18n'
import http from './../../../../core/services/http.service';

export default {
  createAddress(data) {
    return http.post('/api/v1/customers/addresses/', data);
  },
  updateAddress(uuid, data) {
    return http.put(`/api/v1/customers/addresses/${uuid}/`, data);
  },
  removeAddress(uuid) {
    return http.delete(`/api/v1/customers/addresses/${uuid}/`)
  },
  getAddressTypes() {
    return [
      {
        key: i18n.t('Billing'),
        value: 'billing'
      },
      {
        key: i18n.t('Shipping'),
        value: 'shipping'
      }
    ];
  }
};
